// eslint-disable-next-line import/no-extraneous-dependencies
import { GeoJsonLayer } from '@deck.gl/layers/typed';
// import { DataFilterExtension } from '@deck.gl/extensions/typed';
import hexRgb from 'hex-rgb';
import { PathStyleExtension } from '@deck.gl/extensions/typed';

export const hexToRgb = (hexCode: string): [number, number, number, number] => {
    let color = hexRgb(hexCode, { format: 'array' });
    let alpha = color.pop();
    color.push((alpha ?? 1) * 255);
    return color;
};

// const dataFilter = new DataFilterExtension({
//     filterSize: 1,
//     fp64: false,
//     countItems: false,
// });

const generateGeoJsonLayer = (
    id: string,
    type: string,
    data: any,
    visible = true,
    opacity = 1.0,
    isFill = false,
    lineColor: string = '#97dbf9',
    fillColor: string = '#86a2b396',
    pointRadius: number = 1000,
    lineWidth: number = 0.5
): GeoJsonLayer<any> => {
    return new GeoJsonLayer({
        id: id,
        data: data,
        pickable: false,
        visible: visible,
        opacity: opacity,
        stroked: true,
        filled: isFill,
        extruded: false,
        lineWidthMinPixels: 2,
        pointType: 'circle',
        getFillColor: hexToRgb(fillColor),
        getLineColor: hexToRgb(lineColor),
        getLineWidth: lineWidth,
        getPointRadius: pointRadius,

        transitions: {
            getFillColor: 500,
            getLineColor: 500,
            opacity: 500,
            // getLineWidth: 500,
            getPointRadius: 500,
        },
        getDashArray: type === 'dashed_line' ? [10, 5] : null,
        dashJustified: true,
        dashGapPickable: true,
        extensions: [new PathStyleExtension({ dash: true })],
    });
};

export default generateGeoJsonLayer;
